import rowUrl from './row.html';
export default function task() {
  return {
    restrict: 'E',
    templateUrl: rowUrl,
    scope: {
      task: '=',
      fromColumn: '@',
    },
    controllerAs: 'ctrl',
    controller(Authentication, $scope) {
      'ngInject';

      this.task = $scope.task;
      this.authentication = Authentication;
    },
  };
}
